import Checkbox from '@/common/components/Inputs/Checkbox/Checkbox';

export default Checkbox;
